import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauActualiseEtatAction from '../actions/BordereauActualiseEtatAction';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauRelancerFlux360Action from '../actions/BordereauRelancerFlux360Action';
import BordereauRelancerFluxAction from '../actions/BordereauRelancerFluxAction';
import BaseBordereauState from './BaseBordereauState';

class BordereauPesEnInstanceState extends BaseBordereauState {
	constructor() {
		super();
		this.step = BordereauStateStep.PES_EN_INSTANCE;
		this.state = BordereauStateType.PES_EN_INSTANCE;
		this.color = '#FFA742';
		this.libelle = 'PES en instance';
	}

	getBordereauActions(
		_bordereau: BordereauWithState,
	): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
		return [
			new BordereauRelancerFluxAction(),
			new BordereauRelancerFlux360Action(),
			new BordereauDupliquerAction(),
			new BordereauActualiseEtatAction(),
		];
	}

	getMouvementActions(
		userRole: UserRole,
	): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
		return [
			new MouvementModifierAction({ isReadonly: true }),
			...(userRole === UserRole.ADMIN
				? [new MouvementModifierAction({ isSuperUser: true })]
				: []),
		];
	}
}

export default BordereauPesEnInstanceState;
